import React, { useState } from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBan, faCamera, faCircleExclamation, faFileInvoice, faHeadphones, faVideo} from "@fortawesome/free-solid-svg-icons";
import cx from "classnames";
import {randstr, replaceSymbolsToHtml, CratioDropDown} from "../../../../../Common/Appcommon";
import {getInitials} from "../../../utils/common";
import Icon from "../../../components/Icon";
import media from "../../../assets/images/women.jpeg";
import favIcon from "../../../../../assets/utils/images/favicon.png"
import CratioTooltip from "../../../../../Common/CratioTooltip";

const Convo = ({ lastMsgRef, messages: allMessages, replyRef, customSelectOptions }) => {
	const dates = Object.keys(allMessages);
	const [hoveredClass, setHoverdClass] = useState(null);

	const handleMouseHover = (divId = null) => {
		setHoverdClass(divId);
	};

	return dates.map((date, dateIndex) => {
		const messages = allMessages[date];	
		
		return (
			<div key={dateIndex}>
				<div className="chat__date-wrapper">
					<span className="chat__date"> {date}</span>
				</div>
				{dateIndex === 0 && (
					<p className="chat__encryption-msg hide">
						<Icon id="lock" className="chat__encryption-icon" />
						Messages are end-to-end encrypted. No one outside of this chat, not
						even WhatsApp, can read or listen to them. Click to learn more.
					</p>
				)}
				<div className="chat__msg-group">
					{messages.map((message, msgIndex) => {
						const isInboundFailed = message.sender && message.status === "failed";
						const assignRef = () =>
							dateIndex === dates.length - 1 && msgIndex === messages.length - 1
								? lastMsgRef
								: undefined;

						const getReplyIcon = (contenttype) => {
							let icon = faFileInvoice;
							if(contenttype === 'image'){
								icon = faCamera;
							}else if(contenttype === 'document'){
								icon = faFileInvoice;
							}else if(contenttype === 'audio'){
								icon = faHeadphones;
							}else if(contenttype === 'video'){
								icon = faVideo;
							}

							return icon;
						}

						const scrollToView = (id) => {
							if(replyRef !== undefined && replyRef.current[id] !== undefined && replyRef.current[id] !== null){
								replyRef.current[id].scrollIntoView();
							}
						}

						let errorId = randstr('err_icon');
						let senderInfoId = randstr('senderinfo_');
						return (
							<>
								{message.image ? (
									<div
										className={`chat__msg chat__img-wrapper ${
											message.sender ? "chat__msg--rxd" : "chat__msg--sent"
										}`}
										ref={assignRef()}
									>
										<img src={media} alt="" className="chat__img" />
										<span className={`chat__msg-footer ${message.isBodyText ? '' : 'msg-without-text'}`}>
											<span>{/*formatTime(message.time)*/message.time}</span>
											{!message.sender && (
												<Icon
													id={
														(message?.status === "sent" || message?.status === "undeliverable" || message?.status === "failed")
															? "singleTick"
															: "doubleTick"
													}
													aria-label={message?.status}
													className={`chat__msg-status-icon ${
														message?.status === "read"
															? "chat__msg-status-icon--blue"
															: ""
													}`}
												/>
											)}
										</span>

										<button
											aria-label="Message options"
											className="chat__msg-options hide"
										>
											<Icon id="downArrow" className="chat__msg-options-icon" />
										</button>
									</div>
								) : message.sender ? (
									<p 
										className={`chat__wrapper chat__wrapper_rxd`} 
										onMouseEnter={() => handleMouseHover('custom_tag_' + msgIndex)}
										onMouseLeave={handleMouseHover}
									>
										{
											(message?.status === 'failed' || message?.status === "undeliverable") &&
											<>
												<span id={ `${errorId}` } title={message.error !== undefined && message.error !== "" ? message.error : "error"} className={`chat__failed_icon mr-1`}>
													<FontAwesomeIcon icon={faCircleExclamation}/>
												</span>
											</>
										}
										{/*{
											message.error !== undefined && message.error !== '' &&
											<UncontrolledPopover placement={"bottom"} trigger="hover" fade={false} target={ `${errorId}` }>
												<PopoverBody className={`le-tooltip`}>
													{ message.error }
												</PopoverBody>
											</UncontrolledPopover>
										}*/}
										<p className="chat__msg chat__msg--rxd" ref={assignRef()}>
											<div ref={el => replyRef.current[message.id] = el}>
												{
													message.replycontent !== undefined &&
													message.replycontent.content !== '' &&
													<div className={`chat__reply_wrapper`}>
														<div className={`chat__reply-quotedmsg`}>
															<div className={`chat__reply-button`} onClick={()=>scrollToView(message.replyid)}>
																<span className={`chat__reply-leftbar`} />
																<div className={`chat__reply-contentwarpper`}>
																	<div className={`chat__reply-contentbox`}>
																		<div className={`chat__reply-content`}>
																			{
																				message.replycontent.type !== 'text' &&
																				<div className={`chat__reply-iconwrapper`}>
																					<div>
																						<FontAwesomeIcon icon={getReplyIcon(message.replycontent.type)} />
																					</div>
																				</div>
																			}
																			<span>
																			{message.replycontent.content}
																		</span>
																		</div>
																	</div>
																</div>
																{
																	message.replycontent.type === 'image' &&
																	message.replycontent.link !== undefined &&
																	message.replycontent.link !== '' &&
																	<div className={`chat__reply-imagewarpper`}>
																		<div className={`chat__reply-imagecontent`}>
																			<div className={`chat__reply-image`} style={{backgroundImage: `url(${message.replycontent.link})` }}/>
																		</div>
																	</div>
																}
															</div>
														</div>
													</div>
												}
												{message.status === "DELETED" ? 
													<span className="del-msg">
														<FontAwesomeIcon icon={faBan} /> {replaceSymbolsToHtml("&nbsp; _Message Deleted by *" + message.updated_username + "* \n\n _", true)} 
													</span>	
													:
													<span>
														{message.content}
													</span>
												}
												<span className={`chat__msg-footer ${message.isBodyText || message.status === "DELETED" || isInboundFailed ? 'msg-text' : 'msg-without-text1'}`}>
													{/*formatTime(message.time)*/message.time}
												</span>
												<button
													aria-label="Message options"
													className="chat__msg-options hide"
												>
													<Icon id="downArrow" className="chat__msg-options-icon" />
												</button>
											</div>
										</p>
										<span className={hoveredClass === 'custom_tag_' + msgIndex ? "msg-down-arrow" : "hide"}>
											{(message.status !== "DELETED" && !isInboundFailed) && CratioDropDown(customSelectOptions, message.convoId)}
										</span>
										{/* {
											message.status !== "DELETED" && 
											<span className={hoveredClass === 'custom_tag_' + msgIndex ? "msg-down-arrow" : "hide"} ><FontAwesomeIcon icon={faAngleDown} onClick={e => {deleteConversation(message.convoId)}} className="cursor-hover"/></span>
										} */}
										{/* {
											message.status !== "DELETED" &&
											<p className={hoveredClass === 'custom_tag_' + msgIndex ? "" : "hide"}>
												<FontAwesomeIcon icon={faTrash} onClick={e => {deleteConversation(message.convoId)}} className={"mL10 cursor-pointer"}/>
											</p>
										} */}
									</p>
								) : (
									<p className={`chat__wrapper chat__wrapper_send`}>

										{
											(message?.status === "failed" || message?.status === "undeliverable") &&

												<CratioTooltip
													title={message.error !== undefined && message.error !== "" ? message.error : "error"}
													content={
														<span
															id={errorId}
															className={`chat__failed_icon mr-1`}>
																<FontAwesomeIcon icon={faCircleExclamation} />
														</span>
													}
												/>
											// <>
											// 	<span id={ `${errorId}` } title={message.error !== undefined && message.error !== "" ? message.error : "error"} className={`chat__failed_icon mr-1`}>
													
											// 	</span>
											// </>
										}
										{/*{
											message.error !== undefined && message.error !== '' &&
											<UncontrolledPopover placement={"bottom"} trigger="hover" fade={false} target={ `${errorId}` }>
												<PopoverBody className={`le-tooltip`}>
													{ message.error }
												</PopoverBody>
											</UncontrolledPopover>
										}*/}
										<p className={cx("chat__msg chat__msg--sent ",
											{'msg-with-header' : (message.headerFormat !== undefined && message.headerFormat !== "text")},
											{'carousel-msg': message.headerFormat === 'CAROUSEL'}
										)} ref={assignRef()}>
											<div ref={el => replyRef.current[message.id] = el}>
												{
													message.replycontent !== undefined &&
													message.replycontent.content !== '' &&
													<div className={`chat__reply_wrapper`}>
														<div className={`chat__reply-quotedmsg`}>
															<div className={`chat__reply-button`} onClick={()=>scrollToView(message.replyid)}>
																<span className={`chat__reply-leftbar`} />
																<div className={`chat__reply-contentwarpper`}>
																	<div className={`chat__reply-contentbox`}>
																		<div className={`chat__reply-content`}>
																			{
																				message.replycontent.type !== 'text' &&
																				<div className={`chat__reply-iconwrapper`}>
																					<div>
																						<FontAwesomeIcon icon={getReplyIcon(message.replycontent.type)} />
																					</div>
																				</div>
																			}
																			<span>
																				{message.replycontent.content}
																		</span>
																		</div>
																	</div>
																</div>
																{
																	message.replycontent.type === 'image' &&
																	message.replycontent.link !== undefined &&
																	message.replycontent.link !== ''&&
																	<div className={`chat__reply-imagewarpper`}>
																		<div className={`chat__reply-imagecontent`}>
																			<div className={`chat__reply-image`} style={{backgroundImage: `url(${message.replycontent.link})` }}/>
																		</div>
																	</div>
																}
															</div>
														</div>
													</div>
												}
												<span className="inbox-messages-alignment">{message.content}</span>
												{!message.isBodyText && message.senderInfo.type != 'Bot' && <div className={'footer-bg'}></div>}
												<span className={`chat__msg-footer ${message.isBodyText || !message.isBodyText && message.senderInfo.type == 'Bot'? 'msg-text' : 'msg-without-text'} `}>
											<span> {/*formatTime(message.time)*/message.time} </span>
											<Icon
												id={
														(message?.status === "sent" || message?.status === "undeliverable" || message?.status === "failed" )
														? "singleTick"
														: "doubleTick"
												}
												aria-label={message?.status}
												className={`chat__msg-status-icon ${
													message?.status === "read"
														? "chat__msg-status-icon--blue"
														: ''
												}${message?.status === "read" || message.isBodyText || (!message.isBodyText && message.senderInfo.type == 'Bot') ? '' : ' chat__msg-status-icon--white'}`}
											/>
										</span>
												<button
													aria-label="Message options"
													className="chat__msg-options hide"
												>
													<Icon id="downArrow" className="chat__msg-options-icon" />
												</button>
											</div>
										</p>
										{/*{	message.senderInfo !== undefined && message.senderInfo.type !== undefined &&
											<UncontrolledPopover placement={"bottom"} trigger="hover" fade={false} target={ `${senderInfoId}` }>
												<PopoverBody className={`le-tooltip le-sender-tooltip`}>
													{ `${message.senderInfo.type}: ${message.senderInfo.name !== undefined ? message.senderInfo.name : ''}` }
												</PopoverBody>
											</UncontrolledPopover>
										}*/}
										{
											<>
												{
													message.senderInfo !== undefined &&
													<div className={`chat_senderinfo`}>
														<div id={ `${senderInfoId}` } className="chat__senderinfo__avatar-wrapper">
															{
																message.senderInfo.type !== undefined && message.senderInfo.type === 'User' ?
																	<CratioTooltip id={`auto_${message.convoId}`} title={`${message.senderInfo.type}: ${message.senderInfo.name !== undefined ? message.senderInfo.name : ''}`} content={<span className="senderCircle ml-1">{getInitials(message.senderInfo.name !== undefined ? message.senderInfo.name : '')}</span>} />
																	 :
																	<CratioTooltip id={message.convoId} title={`${message.senderInfo.type}: ${message.senderInfo.name !== undefined ? message.senderInfo.name : ''}`} content={<img src={favIcon} alt={message.senderInfo.name !== undefined ? message.senderInfo.name : 'sender-avatar'} className={`chat_senderinfo__avatar ml-1`} />} />

															}
														</div>
													</div>
												}
											</>
										}
									</p>
								)}
							</>
						);
					})}
				</div>
			</div>
		);
	});
};

export default Convo;
